import { useSnapshot } from 'valtio'
import { activeModalStack, hideModal } from '../globalState'
import { options } from '../optionsStorage'
import TouchAreasControls from './TouchAreasControls'
import { packetsReplayState } from './state/packetsReplayState'
import { useIsModalActive, useUsingTouch } from './utilsApp'

export default () => {
  const usingTouch = useUsingTouch()
  const hasModals = useSnapshot(activeModalStack).length !== 0
  const setupActive = useIsModalActive('touch-buttons-setup')
  const { isOpen: replayOpen } = useSnapshot(packetsReplayState)

  // Nothing to move in the replay player — the movement pads stay off there.
  if (replayOpen && !setupActive) return null

  return <TouchAreasControls
    foregroundGameActive={!!bot && !!usingTouch && !hasModals}
    setupActive={setupActive}
    closeButtonsSetup={(newPositions) => {
      if (newPositions) {
        options.touchControlsPositions = newPositions
      }
      hideModal()
    }}
  />
}
